import React, { useState } from "react";
import HowToPlayModal from "../../../common/HowToPlayModal";
import PlotleStepsContent from "./PlotleStepsContent";

const steps = [
  { title: "1", description: "Overview" },
  { title: "2", description: "How-To" },
  { title: "3", description: "Goal" },
];

const HowToPlayPlotleModal = () => {
  const [step, setStep] = useState(1);

  return (
    <HowToPlayModal
      steps={steps}
      content={<PlotleStepsContent step={step} />}
      step={step}
      setStep={setStep}
    />
  );
};

export default HowToPlayPlotleModal;
